import en from './en';
import es from './es';

const locales = {
  en,
  es,
};

export default locales;
